import { render, staticRenderFns } from "./HandoverList.vue?vue&type=template&id=91e6c37c&"
import script from "./HandoverList.vue?vue&type=script&lang=js&"
export * from "./HandoverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports